var $a2ec1bfcd7856caa$exports = {};
$a2ec1bfcd7856caa$exports = {
    "removeButtonLabel": `\u{524A}\u{9664}`,
    "removeDescription": `\u{30BF}\u{30B0}\u{3092}\u{524A}\u{9664}\u{3059}\u{308B}\u{306B}\u{306F}\u{3001}Delete \u{30AD}\u{30FC}\u{3092}\u{62BC}\u{3057}\u{307E}\u{3059}\u{3002}`
};


export {$a2ec1bfcd7856caa$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
